(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    const scrollToHash = () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({ behavior: 'instant' });
        return true;
      }
      return false;
    };

    // Try immediately on DOMContentLoaded
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        // If card not found yet (might be loading via pagination), wait for it
        if (!scrollToHash()) {
          // Use MutationObserver to wait for the element to appear
          const observer = new MutationObserver(() => {
            if (scrollToHash()) {
              observer.disconnect();
            }
          });

          observer.observe(document.body, {
            childList: true,
            subtree: true
          });

          // Fallback: stop observing after 2 seconds to prevent infinite waiting
          setTimeout(() => observer.disconnect(), 2000);
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
